import styled from 'styled-components';
import palette from '@mlc/mlc-palette';
import { ScreenSize } from '../../../../enums';

export const Button = styled.button`
	background: ${palette.mlcKoala};
	border: 0;
	box-shadow: none;
	color: ${palette.mlcOrange};
	cursor: pointer;
	font-size: 18px;
	height: 50px;
	line-height: normal;
	padding-bottom: 4px;
	padding-left: 6px;
	padding-right: 6px;
	padding-top: 4px;
	position: inherit;
	width: 50px;

	&:hover {
		background-color: ${palette.mlcWallaby};
		color: ${palette.mlcWhite};
	}
`;

export const SearchDiv = styled.div`
	@media (min-width: ${ScreenSize.xSmall}) {
		position: relative;
	}
`;
